<template>
  <div>
    <el-tabs
    type="border-card"
    @tab-click="tabClick"
    v-model="activeName"
    >
      <el-tab-pane
      label="查询"
      name="first"
      >
        <h2 class="el_h2">基础信息</h2>
        <!-- 查询表单 -->
        <el-form
        ref="device_form"
        :model="device_form"
        label-width="100px"
        class="device_form"
        >
          <el-form-item label="关键字" prop="key">
            <el-input v-model="device_form.key" placeholder="设备ID/设备名称/设备规格"></el-input>
          </el-form-item>
          <el-form-item label="设备类型" prop="deviceType">
            <el-select
            style="width: 100%;"
            :popper-append-to-body="false"
            v-model="device_form.deviceType"
            placeholder="请选择设备类型"
            clearable
            >
              <el-option
              v-for="item in device_type"
              :key="item.value"
              :label="item.name"
              :value="item.value"
              :disabled="item.disabled"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="设备状态" prop="deviceStatus">
            <el-select
            style="width: 100%;"
            :popper-append-to-body="false"
            v-model="device_form.deviceStatus"
            placeholder="请选择设备状态"
            clearable
            >
              <el-option
              v-for="item in device_status"
              :key="item.value"
              :label="item.name"
              :value="item.value"
              :disabled="item.disabled"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="设备属性" prop="deviceAtt">
            <el-select
            style="width: 100%;"
            :popper-append-to-body="false"
            v-model="device_form.deviceAtt"
            placeholder="请选择设备属性"
            clearable
            >
              <el-option
              v-for="item in device_att"
              :key="item.value"
              :label="item.name"
              :value="item.value"
              :disabled="item.disabled"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button
            v-if="btn_permission.includes('middle:device:list')||btn_permission.includes('superAdmin')"
            @click="search_device()"
            type="primary">查询</el-button>
            <el-button
            v-if="btn_permission.includes('middle:device:list')||btn_permission.includes('superAdmin')"
            @click="reset_device()">重置</el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>
      <el-tab-pane
      label="列表"
      name="second"
      >
        <h2 class="el_h2">设备列表</h2>
        <!-- 设备列表 -->
        <el-table
        v-loading="list_loading"
        :data="listData"
        border
        highlight-current-row
        max-height="400"
        @row-dblclick="check_detail"
        id="device_list"
        >
          <el-table-column
          align="center"
          type="index"
          label="NO"></el-table-column>
          <el-table-column
          align="center"
          show-overflow-tooltip
          label="设备编号"
          prop="deviceId"></el-table-column>
          <el-table-column
          align="center"
          prop="deviceName"
          show-overflow-tooltip
          label="设备名称"></el-table-column>
          <el-table-column
          align="center"
          prop="deviceSpec"
          show-overflow-tooltip
          label="型号"></el-table-column>
          <el-table-column align="center" prop="verifyFlag" label="审核状态"></el-table-column>
          <el-table-column
          align="center"
          show-overflow-tooltip
          prop="procureDate"
          label="购入时间"></el-table-column>
          <el-table-column
          align="center"
          show-overflow-tooltip
          prop="activeDate"
          label="启用时间"></el-table-column>
          <el-table-column align="center" prop="deviceStatus" label="设备状态">
            <template slot-scope="scope">
              <span v-show="scope.row.deviceStatus=='1'">待审</span>
              <span v-show="scope.row.deviceStatus=='2'">正常</span>
              <span v-show="scope.row.deviceStatus=='3'">待返</span>
              <span v-show="scope.row.deviceStatus=='4'">冻结</span>
              <span v-show="scope.row.deviceStatus=='5'">遗失</span>
              <span v-show="scope.row.deviceStatus=='6'">损坏</span>
            </template>
          </el-table-column>
          <el-table-column
          align="center"
          show-overflow-tooltip
          prop="deviceType"
          label="设备类型"></el-table-column>
          <el-table-column
          align="center"
          show-overflow-tooltip
          prop="deviceAtt"
          label="设备属性"></el-table-column>
          <el-table-column
          align="center"
          show-overflow-tooltip
          prop="notes"
          label="备注"></el-table-column>
        </el-table>
        <!-- 设备列表分页 -->
        <el-pagination
        style="margin: 10px auto;"
        background
        @size-change="pageparm_size_change"
        @current-change="pageparm_current_change"
        :current-page="pageparm.currentPage"
        :page-sizes="[10, 15, 20, 25]"
        :page-size="pageparm.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageparm.total"
        ></el-pagination>
      </el-tab-pane>
      <el-tab-pane
      label="明细"
      name="third"
      >
        <el-row class="el_details_row">
          <!-- 明细设备列表 -->
          <el-table
          :data="listData"
          highlight-current-row
          @row-dblclick="db_details"
          class="details_table"
          ref="details_table"
          >
            <el-table-column
            align="center"
            type="index"
            label="NO"
            ></el-table-column>
            <el-table-column
            align="center"
            show-overflow-tooltip
            label="设备编号"
            prop="deviceId"
            ></el-table-column>
            <el-table-column align="center" prop="deviceName" label="设备名称"></el-table-column>
            <el-table-column align="center" prop="verifyFlag" label="审核状态"></el-table-column>
          </el-table>
          <el-tabs
          type="border-card"
          v-model="detail_active"
          class="details_tabs"
          >
            <el-tab-pane
            label="主信息"
            name="1"
            >
              <el-form
              ref="details_form1"
              :model="details_form1"
              label-width="80px"
              class="details_form1"
              :rules="main_info"
              >
                <el-divider content-position="left">基础信息</el-divider>
                <el-form-item label="设备编号" prop="deviceId">
                  <el-input placeholder="设备编号" :disabled="deviceId_status" v-model="details_form1.deviceId"></el-input>
                </el-form-item>
                <el-form-item label="设备名称" prop="deviceName">
                  <el-input placeholder="设备名称" v-model="details_form1.deviceName"></el-input>
                </el-form-item>
                <el-form-item label="设备规格" prop="deviceSpec">
                  <el-input placeholder="设备规格" v-model="details_form1.deviceSpec"></el-input>
                </el-form-item>
                <el-form-item label="设备类型" prop="deviceType">
                  <el-select
                  :popper-append-to-body="false"
                  style="width: 100%;"
                  v-model="details_form1.deviceType"
                  :disabled="deviceType_status"
                  >
                    <el-option
                    v-for="item in device_type"
                    :key="item.value"
                    :label="item.name"
                    :value="item.value"
                    :disabled="item.disabled"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="设备属性" prop="deviceAtt">
                  <el-select
                  style="width: 100%;"
                  :popper-append-to-body="false"
                  v-model="details_form1.deviceAtt"
                  >
                    <el-option
                    v-for="item in device_att"
                    :key="item.value"
                    :label="item.name"
                    :value="item.value"
                    :disabled="item.disabled"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="设备状态">
                  <el-input :disabled="true" v-model="details_device_status"></el-input>
                </el-form-item>
                <el-divider content-position="left">相关时间</el-divider>
                <el-form-item label="购入时间" prop="procureDate">
                  <el-date-picker
                  v-model="details_form1.procureDate"
                  type="date"
                  style="width: 100%;"
                  placeholder="购入时间"
                  :disabled="procureDate_status"
                  value-format="yyyy-MM-dd"
                  ></el-date-picker>
                </el-form-item>
                <el-form-item label="启用时间" prop="activeDate">
                  <el-date-picker
                  v-model="details_form1.activeDate"
                  type="date"
                  style="width: 100%;"
                  placeholder="启用时间"
                  :disabled="activeDate_status"
                  value-format="yyyy-MM-dd"
                  ></el-date-picker>
                </el-form-item>
                <el-divider content-position="left">相关出厂属性</el-divider>
                <el-form-item label="温度上限" prop="tUpLimit">
                  <el-input placeholder="温度上限" v-model="details_form1.tUpLimit"></el-input>
                </el-form-item>
                <el-form-item label="温度下限" prop="tLowerLimit">
                  <el-input placeholder="温度下限" v-model="details_form1.tLowerLimit"></el-input>
                </el-form-item>
                <el-form-item label="湿度上限" prop="hUpLimit">
                  <el-input placeholder="湿度上限" v-model="details_form1.hUpLimit"></el-input>
                </el-form-item>
                <el-form-item label="湿度下限" prop="hLowerLimit">
                  <el-input placeholder="湿度下限" v-model="details_form1.hLowerLimit"></el-input>
                </el-form-item>
                <el-divider content-position="left">备注</el-divider>
                <el-form-item style="width: 100%;" label="备注" prop="notes">
                  <el-input placeholder="备注" v-model="details_form1.notes"></el-input>
                </el-form-item>
                <el-form-item class="operate_button">
                  <el-button
                  size="mini"
                  type="primary"
                  :disabled="add_device_status"
                  @click="add_device"
                  class="operate_btn"
                  v-if="btn_permission.includes('middle:device:add')||btn_permission.includes('superAdmin')"
                  >新增设备</el-button>
                  <el-button
                  size="mini"
                  type="primary"
                  :disabled="delete_device_status"
                  @click="delete_device"
                  class="operate_btn"
                  v-if="btn_permission.includes('middle:device:del')||btn_permission.includes('superAdmin')"
                  >删除设备</el-button>
                  <el-button
                  size="mini"
                  type="success"
                  :disabled="edit_device_status"
                  @click="edit_device"
                  class="operate_btn"
                  v-if="btn_permission.includes('middle:device:update')||btn_permission.includes('superAdmin')"
                  >修改设备</el-button>
                  <el-button
                  size="mini"
                  type="infor"
                  :disabled="save_device_status"
                  @click="save_device"
                  class="operate_btn"
                  >保存</el-button>
                  <el-button
                  size="mini"
                  type="infor"
                  :disabled="cancel_operate_status"
                  @click="cancel_operate"
                  class="operate_btn"
                  >取消</el-button>
                  <el-button
                  size="mini"
                  type="success"
                  class="operate_btn"
                  @click="deviceToExcel"
                  v-if="btn_permission.includes('middle:device:downloadTemplate')||btn_permission.includes('superAdmin')"
                  >设备模板下载</el-button>
                  <el-upload
                  :action="publicAjax.extra_path+'/middle/device/import'"
                  :auto-upload="true"
                  :headers="{'scctoken':upload_token}"
                  name="file"
                  :on-success="success_file"
                  :file-list="device_file"
                  :show-file-list="false"
                  ref="device_upload"
                  v-if="btn_permission.includes('middle:device:import')||btn_permission.includes('superAdmin')"
                  >
                    <el-button
                    size="mini"
                    type="success"
                    class="operate_btn"
                    >导入设备</el-button>
                  </el-upload>
                </el-form-item>
              </el-form>
            </el-tab-pane>
            <el-tab-pane
            label="其他信息"
            name="2"
            >
              <el-form
              ref="other_info"
              :model="other_info"
              label-width="100px"
              class="other_info"
              >
                <el-divider content-position="left">建档信息</el-divider>
                <el-form-item label="创建人">
                  <el-input disabled v-model="other_info.addWho"></el-input>
                </el-form-item>
                <el-form-item label="创建时间">
                  <el-input disabled v-model="other_info.addTime"></el-input>
                </el-form-item>
                <el-form-item label="上次使用">
                  <el-input disabled v-model="other_info.lastTimeUsed"></el-input>
                </el-form-item>
                <el-form-item label="上次绑定箱号">
                  <el-input disabled v-model="other_info.lastTraceId"></el-input>
                </el-form-item>
              </el-form>
            </el-tab-pane>
            <el-tab-pane
            label="设备多仓"
            name="3"
            >
              <h2 class="el_h2">关联仓库</h2>
              <!-- 设备多仓列表 -->
              <el-table
              :data="deviceData"
              border
              ref="device_selection"
              class="device_data"
              @selection-change="handleChange"
              >
                <el-table-column type="index" align="center" label="序号"></el-table-column>
                <el-table-column
                align="center"
                label="仓库ID"
                show-overflow-tooltip
                prop="deviceWarehouseId"></el-table-column>
                <el-table-column
                align="center"
                label="仓库名"
                show-overflow-tooltip
                prop="deviceWarehouseName"></el-table-column>
                <el-table-column
                :selectable="selectEnable"
                type="selection"
                align="center">
                </el-table-column>
              </el-table>
              <!-- 设备多仓分页 -->
              <el-pagination
              style="margin: 10px auto;"
              background
              @size-change="pageparms_size_change"
              @current-change="pageparms_current_change"
              :current-page="pageparms.currentPage"
              :page-sizes="[10, 15, 20, 25]"
              :page-size="pageparms.pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="pageparms.total"
              ></el-pagination>
              <el-button
              type="primary"
              @click="bind_storage()"
              v-if="btn_permission.includes('middle:device:warehoserBind')||btn_permission.includes('superAdmin')"
              >设备绑定仓位</el-button>
            </el-tab-pane>
            <el-tab-pane
            label="设备审批"
            name="4"
            >
              <h2 class="el_h2">设备审批</h2>
              <!-- 设备审批列表 -->
              <el-table
              :data="approvalData"
              ref="approval_data"
              border
              highlight-current-row
              @row-dblclick="check_approvalDetails"
              >
                <el-table-column
                align="center"
                label="设备编号"
                show-overflow-tooltip
                prop="deviceId"
                ></el-table-column>
                <el-table-column
                align="center"
                label="证照名称"
                show-overflow-tooltip
                prop="approveFileName"
                ></el-table-column>
                <el-table-column
                align="center"
                label="证照编号"
                show-overflow-tooltip
                prop="approveNo"
                ></el-table-column>
                <el-table-column
                align="center"
                label="上传文件名"
                show-overflow-tooltip
                prop="serverFileName"
                ></el-table-column>
                <el-table-column
                align="center"
                label="备注"
                show-overflow-tooltip
                prop="notes"
                ></el-table-column>
              </el-table>
              <h2 class="el_h2" style="margin: 20px 0;">审批详情</h2>
              <!-- 审批详情 -->
              <el-form
              ref="approval_form"
              :model="approval_form"
              label-width="100px"
              class="approval_form"
              :rules="approval_rules"
              >
                <el-form-item label="设备ID" prop="deviceId">
                  <el-input placeholder="设备ID" :disabled="true" v-model="approval_form.deviceId"></el-input>
                </el-form-item>
                <el-form-item label="证照序列号" prop="fileSeq">
                  <el-input :disabled="true" placeholder="设备序列号" v-model="approval_form.fileSeq"></el-input>
                </el-form-item>
                <el-form-item label="校准日期" prop="approveDate">
                  <el-date-picker
                  v-model="approval_form.approveDate"
                  type="date"
                  style="width: 100%;"
                  placeholder="校准日期"
                  value-format="yyyy-MM-dd"
                  ></el-date-picker>
                </el-form-item>
                <el-form-item label="校准状态" prop="approveFlag">
                  <el-input :disabled="true" placeholder="校准状态" v-model="approval_form.approveFlag"></el-input>
                </el-form-item>
                <el-form-item label="预警天数" prop="alertDays">
                  <el-input type="number" placeholder="预警天数" v-model="approval_form.alertDays"></el-input>
                </el-form-item>
                <el-form-item label="校准周期" prop="approvePeriod">
                  <el-input type="number" placeholder="校准周期" v-model="approval_form.approvePeriod"></el-input>
                </el-form-item>
                <el-form-item label="证照名称" prop="approveFileName">
                  <el-input placeholder="证照名称" v-model="approval_form.approveFileName"></el-input>
                </el-form-item>
                <el-form-item label="证照编号" prop="approveNo">
                  <el-input type="number" placeholder="证照编号" v-model="approval_form.approveNo"></el-input>
                </el-form-item>
                <el-form-item class="deviceLicense_name" label="证照文件名" prop="serverFileName">
                  <el-input placeholder="证照文件名" v-model="approval_form.serverFileName"></el-input>
                </el-form-item>
                <el-form-item class="deviceLicense_path" label="文件路径" prop="serverFileContent">
                  <el-input :disabled="true" placeholder="上传文件路径" v-model="approval_form.serverFileContent"></el-input>
                  <el-upload
                  :action="publicAjax.extra_path+'/sccOwn/upload/file/deviceLicense/'+row_deiceid"
                  :auto-upload="true"
                  :headers="{'scctoken':upload_token}"
                  name="file"
                  accept=".pdf"
                  :on-success="success_deviceLicense"
                  :file-list="deviceLicense_file"
                  :show-file-list="false"
                  ref="deviceLicense_upload"
                  >
                    <el-button
                    size="mini"
                    type="success"
                    class="operate_btn"
                    >导入证照</el-button>
                  </el-upload>
                  <el-button
                  size="mini"
                  type="infor"
                  @click="picture_preview"
                  class="operate_btn"
                  >预览证照</el-button>
                </el-form-item>
                <el-form-item label="创建时间" prop="addTime">
                  <el-input :disabled="true" placeholder="创建时间" v-model="approval_form.addTime"></el-input>
                </el-form-item>
                <el-form-item label="创建人" prop="addWho">
                  <el-input :disabled="true" placeholder="创建人" v-model="approval_form.addWho"></el-input>
                </el-form-item>
                <el-form-item label="修改时间" prop="editTime">
                  <el-input :disabled="true" placeholder="修改时间" v-model="approval_form.editTime"></el-input>
                </el-form-item>
                <el-form-item label="修改人" prop="editWho">
                  <el-input :disabled="true" placeholder="修改人" v-model="approval_form.editWho"></el-input>
                </el-form-item>
                <el-form-item class="approval_notes" label="备注" prop="notes">
                  <el-input placeholder="备注" v-model="approval_form.notes"></el-input>
                </el-form-item>
                <el-form-item class="operate_button">
                  <el-button
                  size="mini"
                  type="primary"
                  :disabled="add_approval_status"
                  @click="add_approval"
                  class="operate_btn"
                  v-if="btn_permission.includes('middle:deviceApprove:add')||btn_permission.includes('superAdmin')"
                  >新增审批</el-button>
                  <el-button
                  size="mini"
                  type="primary"
                  :disabled="delete_approval_status"
                  @click="delete_approval"
                  class="operate_btn"
                  v-if="btn_permission.includes('middle:deviceApprove:del')||btn_permission.includes('superAdmin')"
                  >删除审批</el-button>
                  <el-button
                  size="mini"
                  type="success"
                  :disabled="edit_approval_status"
                  @click="edit_approval"
                  class="operate_btn"
                  v-if="btn_permission.includes('middle:deviceApprove:edit')||btn_permission.includes('superAdmin')"
                  >修改审批</el-button>
                  <el-button
                  size="mini"
                  type="success"
                  :disabled="approval_device_status"
                  @click="approval_device"
                  class="operate_btn"
                  v-if="btn_permission.includes('middle:device:verify')||btn_permission.includes('superAdmin')"
                  >审核设备</el-button>
                  <el-button
                  size="mini"
                  type="infor"
                  :disabled="save_approval_status"
                  @click="save_approval"
                  class="operate_btn"
                  >保存</el-button>
                  <el-button
                  size="mini"
                  type="infor"
                  :disabled="cancel_approval_status"
                  @click="cancel_approval"
                  class="operate_btn"
                  >取消</el-button>
                  <el-button
                  size="mini"
                  type="success"
                  class="operate_btn"
                  @click="approvalToExcel"
                  v-if="btn_permission.includes('middle:deviceApprove:template')||btn_permission.includes('superAdmin')"
                  >审批模板下载</el-button>
                  <el-upload
                  :action="publicAjax.extra_path+'/middle/deviceApprove/import'"
                  :auto-upload="true"
                  :headers="{'scctoken':upload_token}"
                  name="file"
                  :on-success="success_file_approval"
                  :file-list="approval_file"
                  :show-file-list="false"
                  ref="approval_upload"
                  v-if="btn_permission.includes('middle:deviceApprove:import')||btn_permission.includes('superAdmin')"
                  >
                    <el-button
                    size="mini"
                    type="success"
                    class="operate_btn"
                    >导入审批模板</el-button>
                  </el-upload>
                </el-form-item>
              </el-form>
            </el-tab-pane>
          </el-tabs>
        </el-row>
      </el-tab-pane>
    </el-tabs>
    <!-- 预览证照 -->
    <el-dialog
    :append-to-body="true"
    :visible.sync="dialogVisible"
    :fullscreen="true"
    title="预览证照"
    >
      <iframe
      :src="path_url+'?auth_token='+upload_token"
      frameborder="0"
      style="width: 100%;height: 700px"
      ></iframe>
    </el-dialog>
  </div>
</template>

<script>
  import Pagination from '../Pagination'
  import Paginations from '../Pagination_new'
  export default {
    data(){
      return{
        btn_permission:JSON.parse(localStorage.getItem(localStorage.getItem('userName')+'permission')),
        //新增或修改设备判断条件
        add_or_edit:'',
        //新增或修改审批判断条件
        approval_add_edit:'',
        //当前行数据
        now_row_data:[],
        //公用deviceID
        row_deiceid:'',
        //切换tab
        activeName:'first',
        //设备类型下拉框
        device_type:[],
        //设备状态下拉框
        device_status:[],
        //设备属性下拉框
        device_att:[],
        //设备列表
        listData:[],
        //设备列表懒加载
        list_loading:false,
        //设备列表分页
        pageparm:{
          currentPage: 1,
          pageSize: 10,
          total: 10
        },
        //查询表单
        device_form:{
          key:'',
          deviceType:'',
          deviceAtt:'',
          deviceStatus:''
        },
        //明细相关
        //主信息表单
        detail_active:'1',
        details_device_status:'',
        //新增设备表单
        details_form1:{
          deviceId:'',
          deviceName:'',
          deviceSpec:'',
          deviceType:'',
          deviceAtt:'',
          procureDate:'',
          activeDate:'',
          tUpLimit:'',
          tLowerLimit:'',
          hUpLimit:'',
          hLowerLimit:'',
          notes:''
        },
        //主信息表单元素禁用启用状态
        deviceId_status:true,
        deviceType_status:true,
        procureDate_status:true,
        activeDate_status:true,
        add_device_status:false,
        delete_device_status:false,
        edit_device_status:false,
        save_device_status:true,
        cancel_operate_status:true,
        main_info:{},
        //主信息表单新增正则
        main_info_add:{
          deviceId:[
            { required: true, message: '请输入设备编号', trigger: 'blur' }
          ],
          deviceName:[
            { required: true, message: '请输入设备名称', trigger: 'blur' }
          ],
          deviceSpec:[
            { required: true, message: '请输入设备规格', trigger: 'blur' }
          ],
          deviceType:[
            { required: true, message: '请选择设备类型', trigger: 'change' }
          ],
          deviceAtt:[
            { required: true, message: '请选择设备属性', trigger: 'change' }
          ],
          procureDate:[
            {type:'string', required: true, message: '请选择购入时间', trigger: 'change' }
          ],
          activeDate:[
            {type:'string', required: true, message: '请选择启用时间', trigger: 'change' }
          ]
        },
        row_first_now:[],
        //主信息表单修改正则
        main_info_edit:{
          deviceId:[
            { required: true, message: '请输入设备编号', trigger: 'blur' }
          ],
          deviceName:[
            { required: true, message: '请输入设备名称', trigger: 'blur' }
          ],
          deviceSpec:[
            { required: true, message: '请输入设备规格', trigger: 'blur' }
          ],
          deviceType:[
            { required: true, message: '请选择设备类型', trigger: 'change' }
          ],
          deviceAtt:[
            { required: true, message: '请选择设备属性', trigger: 'change' }
          ],
          procureDate:[
            {type:'string', required: true, message: '请选择购入时间', trigger: 'change' }
          ],
          activeDate:[
            {type:'string', required: true, message: '请选择启用时间', trigger: 'change' }
          ]
        },
        //导入设备(上传文件)
        upload_token:localStorage.getItem(localStorage.getItem('userName')+'token'),
        device_file:[],
        //其他信息表单
        other_info:{
          addWho:'',
          addTime:'',
          lastTimeUsed:'',
          lastTraceId:''
        },
        //设备多仓列表
        deviceData:[],
        multipleSelection:[],
        storage_list:[],
        //设备多仓分页
        pageparms:{
          currentPage: 1,
          pageSize: 10,
          total: 10
        },
        //设备审批列表
        approvalData:[],
        //设备审批当前行数据
        approval_now:[],
        //设备审批选中当前行唯一键
        approval_fileSeq:'',
        //设备审批详情表单
        approval_form:{
          deviceId:'',
          fileSeq:'',
          approveDate:'',
          approveFlag:'',
          alertDays:'',
          approvePeriod:'',
          approveFileName:'',
          approveNo:'',
          serverFileName:'',
          serverFileContent:'',
          notes:'',
          addTime:'',
          addWho:'',
          editTime:'',
          editWho:''
        },
        //导入审批
        approval_file:[],
        //设备审批表单元素禁用启用状态
        add_approval_status:false,
        delete_approval_status:false,
        edit_approval_status:false,
        approval_device_status:false,
        save_approval_status:true,
        cancel_approval_status:true,
        approval_rules:{},
        //设备审批表单新增正则
        approval_rules_add:{
          approveDate:[
            {type:'string', required: true, message: '请选择校准日期', trigger: 'change' }
          ],
          approvePeriod:[
            { required: true, message: '请输入设备编号', trigger: 'blur' }
          ]
        },
        //设备审批表单修改正则
        approval_rules_edit:{
          approveDate:[
            {type:'string', required: true, message: '请选择校准日期', trigger: 'change' }
          ]
        },
        //导入证照相关
        deviceLicense_file:[],
        //预览证照
        dialogVisible:false,
        path_url:''
      }
    },
    //注册组件
    components:{
      Pagination,
      Paginations
    },
    created() {
      let that=this
      that.publicAjax.axios_set()
      //设备类型下拉框
      that.$axios({
        method:'get',
        url:that.publicAjax.extra_path+'/admin/dict/select/byCode/tempDeviceType'
      }).then(data=>{
        if(data.data.success==true){
          that.device_type=data.data.data
        }else{
          that.$message.error(data.data.message)
        }
      })
      //设备状态下拉框
      that.$axios({
        method:'get',
        url:that.publicAjax.extra_path+'/middle/device/select/deviceStatus'
      }).then(data=>{
        if(data.data.success==true){
          that.device_status=data.data.data
        }else{
          that.$message.error(data.data.message)
        }
      })
      //设备属性下拉框
      that.$axios({
        method:'get',
        url:that.publicAjax.extra_path+'/middle/device/select/deviceAtt'
      }).then(data=>{
        if(data.data.success==true){
          that.device_att=data.data.data
        }else{
          that.$message.error(data.data.message)
        }
      })
      // //主信息表单正则
      // that.main_info=that.main_info_add
      // //重置表单校验
      // if(that.$refs['details_form1']!=undefined){
      //   that.$refs['details_form1'].clearValidate()
      // }
    },
    mounted() {

    },
    methods:{
      //数组去重
      unique(arr){
        const res=new Map()
        return arr.filter((arr) => !res.has(arr.deviceId) && res.set(arr.deviceId, 1))
      },
      // 父节点tab切换
      tabClick(){

      },
      //设备列表分页
      pageparm_size_change(val){
        this.pageparm.pageSize=val
        //设备列表
        this.device_list()
      },
      pageparm_current_change(val){
        this.pageparm.currentPage=val
        //设备列表
        this.device_list()
      },
      //设备列表
      device_list(){
        let that=this
        that.list_loading=true
        that.$axios.get(that.publicAjax.extra_path+'/middle/device/list',{
          params:{
            page:that.pageparm.currentPage,
            limit:that.pageparm.pageSize,
            key:that.device_form.key,
            deviceType:that.device_form.deviceType,
            deviceAtt:that.device_form.deviceAtt,
            deviceStatus:that.device_form.deviceStatus
          }
        }).then(data=>{
          that.list_loading=false
          if(data.data.success==true){

            that.listData=data.data.data.list
            if(that.row_first_now.length>0){
              that.listData=that.row_first_now.concat(data.data.data.list)
              that.listData=that.unique(that.listData)
            }
            if(that.add_or_edit=='edit'){
              that.listData.forEach(item=>{
                if(item.deviceId==that.now_row_data.deviceId){
                  that.now_row_data=item
                }
              })
              that.db_details(that.now_row_data)
            }else{
              that.db_details(that.listData[0])
            }
            that.pageparm.total=data.data.data.total
          }else{
            that.$message.error(data.data.message)
          }
        })
      },
      //查询设备列表
      search_device(){
        this.pageparm.currentPage=1
        this.pageparm.pageSize=10
        this.activeName='second'
        this.row_first_now=[]
        //设备列表
        this.device_list()
      },
      //重置查询
      reset_device(){
        this.$refs['device_form'].resetFields()
        this.pageparm.currentPage=1
        this.pageparm.pageSize=10
        //设备列表
        this.device_list()
      },
      //查看设备明细
      check_detail(row,column,event){
        this.activeName='third'
        //明细行双击事件
        this.db_details(row,column,event)
      },
      //明细行双击事件
      db_details(row,column,event){
        this.add_or_edit=''
        this.main_info={}
        this.deviceId_status=true
        this.deviceType_status=true
        this.procureDate_status=true
        this.activeDate_status=true
        this.add_device_status=false
        this.delete_device_status=false
        this.edit_device_status=false
        this.save_device_status=true
        this.cancel_operate_status=true
        this.$refs['details_table'].setCurrentRow(row)
        //重置表单校验
        this.$refs['details_form1'].clearValidate()
        this.pageparms.currentPage=1
        this.pageparms.pageSize=10
        //当前行数据
        this.now_row_data=row
        if(row==undefined){
          return false
        }
        //公用deviceID
        this.row_deiceid=row.deviceId
        //设备多仓列表
        this.device_long(row.deviceId)
        //设备审批列表
        this.approval_list(row.deviceId)
        if(row.deviceStatus=='1'){
          this.details_device_status='待审'
        }else if(row.deviceStatus=='2'){
          this.details_device_status='正常'
        }else if(row.deviceStatus=='3'){
          this.details_device_status='待返'
        }else if(row.deviceStatus=='4'){
          this.details_device_status='冻结'
        }else if(row.deviceStatus=='5'){
          this.details_device_status='遗失'
        }else if(row.deviceStatus=='6'){
          this.details_device_status='损坏'
        }
        //主信息表单
        this.details_form1={
          deviceId:row.deviceId,
          deviceName:row.deviceName,
          deviceSpec:row.deviceSpec,
          deviceType:row.deviceType,
          deviceAtt:row.deviceAtt,
          procureDate:row.procureDate,
          activeDate:row.activeDate,
          tUpLimit:row.tupLimit,
          tLowerLimit:row.tlowerLimit,
          hUpLimit:row.hupLimit,
          hLowerLimit:row.hlowerLimit,
          notes:row.notes
        }
        //其他信息表单
        this.other_info={
          addWho:row.addWho,
          addTime:row.addTime,
          lastTimeUsed:row.lastTimeUsed,
          lastTraceId:row.lastTraceId
        }
      },
      //新增设备前置
      add_device(){
        this.row_first_now=[]
        this.deviceId_status=false
        this.deviceType_status=false
        this.procureDate_status=false
        this.activeDate_status=false
        this.add_device_status=true
        this.delete_device_status=true
        this.edit_device_status=true
        this.save_device_status=false
        this.cancel_operate_status=false
        this.add_or_edit='add'
        //主信息表单新增正则
        this.main_info=this.main_info_add
        //重置表单
        this.$refs['details_form1'].resetFields()
      },
      //新增设备/修改设备(保存)
      save_device(){
        let that=this
        that.$refs['details_form1'].validate((valid)=>{
          if(valid){
            if(that.add_or_edit=='add'){
              that.$axios({
                method:'post',
                url:that.publicAjax.extra_path+'/middle/device',
                headers:{
                  "token": localStorage.getItem(localStorage.getItem('userName')+'token'),
                  "content-type":"application/json;charset=UTF-8"
                },
                data:that.details_form1
              }).then(data=>{
                if(data.data.success==true){
                  that.row_first_now.push(data.data.data)
                  //设备列表
                  that.device_list()
                  that.$message.success(data.data.message)
                }else{
                  that.$message.error(data.data.message)
                }
              })
            }else if(that.add_or_edit=='edit'){
              that.$axios({
                method:'put',
                url:that.publicAjax.extra_path+'/middle/device/'+that.row_deiceid,
                headers:{
                  "token": localStorage.getItem(localStorage.getItem('userName')+'token'),
                  "content-type":"application/json;charset=UTF-8"
                },
                data:{
                  deviceName:that.details_form1.deviceName,
                  deviceSpec:that.details_form1.deviceSpec,
                  deviceAtt:that.details_form1.deviceAtt,
                  tUpLimit:that.details_form1.tUpLimit,
                  tLowerLimit:that.details_form1.tLowerLimit,
                  hUpLimit:that.details_form1.hUpLimit,
                  hLowerLimit:that.details_form1.hLowerLimit,
                  notes:that.details_form1.notes
                }
              }).then(data=>{
                if(data.data.success==true){
                  that.row_first_now.push(data.data.data)
                  //设备列表
                  that.device_list()
                  that.$message.success(data.data.message)
                }else{
                  that.$message.error(data.data.message)
                }
              })
            }
          }else{
            return false
          }
        })
      },
      //删除设备
      delete_device(){
        let that=this
        that.$confirm('是否继续?','提示',{
          type:'warning'
        }).then(()=>{
          that.$axios({
            method:'delete',
            url:that.publicAjax.extra_path+'/middle/device/'+that.row_deiceid
          }).then(data=>{
            if(data.data.success==true){
              that.row_first_now=[]
              //设备列表
              that.device_list()
              that.$message.success(data.data.message)
            }else{
              that.$message.error(data.data.message)
            }
          })
        }).catch(()=>{

        })
      },
      //修改设备前置
      edit_device(){
        this.row_first_now=[]
        this.deviceId_status=true
        this.deviceType_status=true
        this.procureDate_status=true
        this.activeDate_status=true
        this.add_device_status=true
        this.delete_device_status=true
        this.edit_device_status=true
        this.save_device_status=false
        this.cancel_operate_status=false
        this.add_or_edit='edit'
        //主信息表单修改正则
        this.main_info=this.main_info_edit
        //重置表单校验
        this.$refs['details_form1'].clearValidate()
      },
      //取消操作
      cancel_operate(){
        //明细行双击事件
        this.db_details(this.now_row_data)
      },
      //设备模板下载
      deviceToExcel(){
        let that=this
        let url='/middle/device/excelTemplate'
        let xmlResquest=new XMLHttpRequest()
        xmlResquest.open('GET',this.publicAjax.extra_path+url,true)
        //设置请求头类型
        xmlResquest.setRequestHeader("Content-type", "application/json")
        xmlResquest.setRequestHeader("scctoken",localStorage.getItem(localStorage.getItem('userName')+'token'))
        xmlResquest.responseType="blob"
        xmlResquest.onreadystatechange=function(){
          if(xmlResquest.status===200){
            if(xmlResquest.readyState===4){
              var content=xmlResquest.response
              if(content.size==104){
                that.$message.warning('暂未授权，无权操作,请联系管理员！')
              }else{
                var elink=document.createElement('a')
                elink.download="设备导入模板.xls"
                elink.style.display='none'
                var blob=new Blob([content])
                elink.href=URL.createObjectURL(blob)
                document.body.appendChild(elink)
                elink.click()
                document.body.removeChild(elink)
              }
            }
          }
        }
        xmlResquest.send()
        return false
        // let that=this
        // that.$axios({
        //   method:'get',
        //   url:that.publicAjax.extra_path+'/middle/device/excelTemplate'
        // }).then(data=>{
        //   if(data.data.success==true){

        //   }else if(data.data.success==false){
        //     that.$message.error(data.data.message)
        //   }
        // })
        // that.publicAjax.exportToExcel('#device_list','设备导入模板')
      },
      //导入设备成功回调
      success_file(data,file,fileList){
        if(data.success==true){
          this.$message.success(data.message)
        }else{
          this.$message.error(data.message)
        }
      },
	  //设备多仓列表分页
	  pageparms_size_change(val){
	    this.pageparms.pageSize=val
	    //设备多仓列表
	    this.device_long(this.row_deiceid)
	  },
	  pageparms_current_change(val){
	    this.pageparms.currentPage=val
	    //设备多仓列表
	    this.device_long(this.row_deiceid)
	  },
      //设备多仓列表
      device_long(id){
        let that=this
        that.$axios.get(that.publicAjax.extra_path+'/middle/deviceMultiWarehouse/list/'+id,{
          params:{
            page:that.pageparms.currentPage,
            limit:that.pageparms.pageSize
          }
        }).then(data=>{
          that.deviceData=data.data.data.list
          that.pageparms.total=data.data.data.total
          that.$nextTick(()=>{
            that.deviceData.forEach(row=>{
              if(row.deviceFlag==1){
                that.$refs['device_selection'].toggleRowSelection(row,true)
              }
            })
          })
        })
      },
      //设备多仓选中事件
      handleChange(row){
        let that=this
        that.multipleSelection=row
      },
      //disable为true为不可选中状态,反之选中
      selectEnable(row, rowIndex){
        if(row.disable==false){
          return true
        }else{
          return false
        }
      },
      //设备绑定仓位
      bind_storage(){
        let that=this
        that.storage_list=[]
        if(that.multipleSelection.length>0){
          that.multipleSelection.forEach(item=>{
            that.storage_list.push({
              deviceWarehouseId:item.deviceWarehouseId,
              deviceFlag:1
            })
          })
        }
        that.$axios({
          method:'post',
          url:that.publicAjax.extra_path+'/middle/deviceMultiWarehouse/bind/'+that.row_deiceid,
          headers:{
            "token": localStorage.getItem(localStorage.getItem('userName')+'token'),
            "content-type":"application/json;charset=UTF-8"
          },
          data:that.storage_list
        }).then(data=>{
          if(data.data.success==true){
            that.$message.success(data.data.message)
            //设备多仓列表
            that.device_long(that.row_deiceid)
          }else{
            that.$message.error(data.data.message)
          }
        })
      },
      //设备审批列表
      approval_list(id){
        let that=this
        that.$axios.get(that.publicAjax.extra_path+'/middle/deviceApprove/list/'+id,{
          params:{
            page:1,
            limit:10
          }
        }).then(data=>{
          if(data.data.success==true){
            that.approvalData=data.data.data.list
            if(that.approval_add_edit=='edit'){
              that.approvalData.forEach(item=>{
                if(item.fileSeq==that.approval_fileSeq){
                  that.approval_now=item
                }
              })
              //查看设备审批列表详情
              that.check_approvalDetails(that.approval_now)
            }else{
              //查看设备审批列表详情
              that.check_approvalDetails(that.approvalData[0])
            }
          }else{
            that.$message.error(data.data.message)
          }
        })
      },
      //查看设备审批列表详情
      check_approvalDetails(row,column,event){
        this.approval_add_edit=''
        this.approval_rules={}
        if(row!=undefined){
          this.approval_fileSeq=row.fileSeq
          this.add_approval_status=false
          this.delete_approval_status=false
          this.edit_approval_status=false
          this.approval_device_status=false
          this.save_approval_status=true
          this.cancel_approval_status=true
          this.$refs['approval_data'].setCurrentRow(row)
          this.$refs['approval_form'].clearValidate()
          this.approval_now=row
          //设备审批详情表单
          this.approval_form={
            deviceId:row.deviceId,
            fileSeq:row.fileSeq,
            approveDate:row.approveDate,
            approveFlag:row.approveFlag,
            alertDays:row.alertDays,
            approvePeriod:row.approvePeriod,
            approveFileName:row.approveFileName,
            approveNo:row.approveNo,
            serverFileName:row.serverFileName,
            serverFileContent:row.serverFileContent,
            notes:row.notes,
            addTime:row.addTime,
            addWho:row.addWho,
            editTime:row.editTime,
            editWho:row.editWho
          }
        }else{
          this.add_approval_status=false
          this.delete_approval_status=false
          this.edit_approval_status=false
          this.approval_device_status=false
          this.save_approval_status=true
          this.cancel_approval_status=true
          this.$refs['approval_form'].resetFields()
        }
      },
      //新增审批前置
      add_approval(){
        this.add_approval_status=true
        this.delete_approval_status=true
        this.edit_approval_status=true
        this.approval_device_status=true
        this.save_approval_status=false
        this.cancel_approval_status=false
        this.approval_add_edit='add'
        //设备审批表单新增正则
        this.approval_rules=this.approval_rules_add
        //重置表单
        this.$refs['approval_form'].resetFields()
      },
      //修改审批前置
      edit_approval(){
        this.add_approval_status=true
        this.delete_approval_status=true
        this.edit_approval_status=true
        this.approval_device_status=true
        this.save_approval_status=false
        this.cancel_approval_status=false
        this.approval_add_edit='edit'
        //设备审批表单修改正则
        this.approval_rules=this.approval_rules_edit
        //重置表单校验
        this.$refs['approval_form'].clearValidate()
      },
      //新增或修改审批保存
      save_approval(){
        let that=this
        that.$refs['approval_form'].validate((valid)=>{
          if(valid){
            if(that.approval_add_edit=='add'){
              that.$axios({
                method:'post',
                url:that.publicAjax.extra_path+'/middle/deviceApprove',
                headers:{
                  "token": localStorage.getItem(localStorage.getItem('userName')+'token'),
                  "content-type":"application/json;charset=UTF-8"
                },
                data:{
                  deviceId:that.row_deiceid,
                  approveDate:that.approval_form.approveDate,
                  approvePeriod:that.approval_form.approvePeriod,
                  approveNo:that.approval_form.approveNo,
                  approveFileName:that.approval_form.approveFileName,
                  alertDays:that.approval_form.alertDays,
                  serverFileName:that.approval_form.serverFileName,
                  serverFileContent:that.approval_form.serverFileContent,
                  notes:that.approval_form.notes
                }
              }).then(data=>{
                if(data.data.success==true){
                  //设备审批列表
                  that.approval_list(that.row_deiceid)
                  that.$message.success(data.data.message)
                }else{
                  that.$message.error(data.data.message)
                }
              })
            }else{
              that.$axios({
                method:'put',
                url:that.publicAjax.extra_path+'/middle/deviceApprove/'+that.row_deiceid+'/'+that.approval_form.fileSeq,
                headers:{
                  "token": localStorage.getItem(localStorage.getItem('userName')+'token'),
                  "content-type":"application/json;charset=UTF-8"
                },
                data:{
                  approveDate:that.approval_form.approveDate,
                  approvePeriod:that.approval_form.approvePeriod,
                  approveNo:that.approval_form.approveNo,
                  approveFileName:that.approval_form.approveFileName,
                  alertDays:that.approval_form.alertDays,
                  serverFileName:that.approval_form.serverFileName,
                  serverFileContent:that.approval_form.serverFileContent,
                  notes:that.approval_form.notes
                }
              }).then(data=>{
                if(data.data.success==true){
                  //设备审批列表
                  that.approval_list(that.row_deiceid)
                  that.$message.success(data.data.message)
                }else{
                  that.$message.error(data.data.message)
                }
              })
            }
          }else{
            return false
          }
        })
      },
      //审核设备
      approval_device(){
        let that=this
        if(that.approvalData.length>0){
          that.$confirm('是否继续?','提示',{
            type:'warning'
          }).then(()=>{
            that.$axios({
              method:'put',
              url:that.publicAjax.extra_path+'/middle/device/verify/'+that.row_deiceid+'/'+that.approval_form.fileSeq
            }).then(data=>{
              if(data.data.success==true){
                //设备审批列表
                that.approval_list(that.row_deiceid)
                that.$message.success(data.data.message)
              }else{
                that.$message.error(data.data.message)
              }
            })
          }).catch(()=>{

          })
        }else{
          that.$message.warning('请先新增审批')
        }
      },
      //新增或修改审批取消
      cancel_approval(){
        //设备审批列表
        this.approval_list(this.row_deiceid)
      },
      //删除审批
      delete_approval(){
        let that=this
        that.$confirm('是否继续?','提示',{
          type:'warning'
        }).then(()=>{
          that.$axios({
            method:'delete',
            url:that.publicAjax.extra_path+'/middle/deviceApprove/'+that.row_deiceid+'/'+that.approval_form.fileSeq
          }).then(data=>{
            if(data.data.success==true){
              //设备审批列表
              that.approval_list(that.row_deiceid)
              that.$message.success(data.data.message)
            }else{
              that.$message.error(data.data.message)
            }
          })
        }).catch(()=>{

        })
      },
      //审批模板下载
      approvalToExcel(){
        let that=this
        let url='/middle/deviceApprove/approveTemplate'
        let xmlResquest=new XMLHttpRequest()
        xmlResquest.open('GET',this.publicAjax.extra_path+url,true)
        //设置请求头类型
        xmlResquest.setRequestHeader("Content-type", "application/json")
        xmlResquest.setRequestHeader("scctoken",localStorage.getItem(localStorage.getItem('userName')+'token'))
        xmlResquest.responseType="blob"
        xmlResquest.onreadystatechange=function(){
          if(xmlResquest.status===200){
            if(xmlResquest.readyState===4){
              var content=xmlResquest.response
              if(content.size==104){
                that.$message.warning('暂未授权，无权操作,请联系管理员！')
              }else{
                var elink=document.createElement('a')
                elink.download="设备审批导入模板.xls"
                elink.style.display='none'
                var blob=new Blob([content])
                elink.href=URL.createObjectURL(blob)
                document.body.appendChild(elink)
                elink.click()
                document.body.removeChild(elink)
              }
            }
          }
        }
        xmlResquest.send()
        return false
      },
      //导入审批模板成功回调
      success_file_approval(data,file,fileList){
        if(data.success==true){
          this.$message.success(data.message)
        }else{
          this.$message.error(data.message)
        }
      },
      //导入证照文件成功回调
      success_deviceLicense(data,file,fileList){
        let that=this
        if(data.success==true){
          that.approval_form.serverFileContent=that.publicAjax.image_path+data.data[0].url
          if(that.approval_form.fileSeq&&that.approval_form.approveDate){
            that.$axios({
              method:'put',
              url:that.publicAjax.extra_path+'/middle/deviceApprove/'+that.row_deiceid+'/'+that.approval_form.fileSeq,
              headers:{
                "token": localStorage.getItem(localStorage.getItem('userName')+'token'),
                "content-type":"application/json;charset=UTF-8"
              },
              data:{
                approveDate:that.approval_form.approveDate,
                approvePeriod:that.approval_form.approvePeriod,
                approveNo:that.approval_form.approveNo,
                approveFileName:that.approval_form.approveFileName,
                alertDays:that.approval_form.alertDays,
                serverFileName:that.approval_form.serverFileName,
                serverFileContent:that.approval_form.serverFileContent,
                notes:that.approval_form.notes
              }
            }).then(data=>{
              if(data.data.success==true){
                //设备审批列表
                that.approval_list(that.row_deiceid)
                that.$message.success(data.data.message)
              }else{
                that.$message.error(data.data.message)
              }
            })
          }else{
            that.$message.warning('请先新增审批')
          }
        }else{
          that.$message.error(data.message)
        }
      },
      //预览证照
      picture_preview(){
        this.dialogVisible=true
        //pdf预览
        this.path_url='./static/pdf/web/viewer.html?file='+encodeURIComponent(this.approval_form.serverFileContent)
      }
    }
  }
</script>

<style scoped="scoped">
  .el_h2{
    border-left: 4px solid #409EFF;
    padding: 10px;
    margin: 0 0 20px;
    font-size: 16px;
    background: #F5F7FA;
  }
  .device_form{
    margin-bottom: 50px;
  }
  .device_form .el-form-item,
  .details_form1 .el-form-item,
  .other_info .el-form-item,
  .approval_form .el-form-item{
    width: 49%;
    display: inline-block;
  }
  .device_form .el-form-item{
    margin-bottom: 30px;
  }
  .device_form .el-form-item:last-child,
  .details_form1 .el-form-item:last-child,
  .approval_form .approval_notes,
  .approval_form .deviceLicense_path,
  .approval_form .deviceLicense_name,
  .approval_form .el-form-item:last-child{
    width: 100%;
  }
  .details_form1 .el-form-item:last-child >>> .el-form-item__content,
  .approval_form .el-form-item:last-child >>> .el-form-item__content{
    margin-left: 0px !important;
  }
  @media screen and (max-width:720px){
    .device_form .el-form-item,
    .details_form1 .el-form-item,
    .other_info .el-form-item,
    .approval_form .el-form-item{
      width: 100%;
    }
  }
  /* 明细相关 */
  .operate_btn{
    margin-right: 0px;
  }
  .operate_btn+.operate_btn{
    margin-left: 0px;
  }
  .el_details_row{
    display: flex;
    justify-content: space-between;
  }
  .details_table{
    width: 38%;
  }
  .details_tabs{
    width: 58%;
    margin-left: 10px;
  }
  .operate_button div,
  .approval_form .deviceLicense_path div{
    display: inline-block;
  }
</style>



// WEBPACK FOOTER //
// src/components/record/device_list.vue